import { render } from "./icon-box.vue?vue&type=template&id=fc0ee122&scoped=true"
import script from "./icon-box.vue?vue&type=script&lang=js"
export * from "./icon-box.vue?vue&type=script&lang=js"

import "./icon-box.vue?vue&type=style&index=0&id=fc0ee122&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0ee122"]])

export default __exports__